import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { usersApi } from '../api/index.js';
import { useAuth } from '../hooks/useAuth.js';
import { ApiError } from '../api/client.js';

export function SettingsPage() {
  const { user } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const mutation = useMutation({
    mutationFn: () => usersApi.update(user!.id, { password: newPassword }),
    onSuccess: () => { setSuccess('Password changed'); setOldPassword(''); setNewPassword(''); },
    onError: (err) => setError(err instanceof ApiError ? err.message : 'Failed to change password'),
  });

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>Settings</h1>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <h2 style={{ fontWeight: 600, marginBottom: '1rem' }}>Profile</h2>
        <dl style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: '.5rem 1rem', fontSize: '.875rem' }}>
          <dt style={{ color: 'var(--color-text-muted)' }}>Username</dt><dd>{user?.username}</dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>Email</dt><dd>{user?.email}</dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>Role</dt><dd>{user?.role}</dd>
        </dl>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <h2 style={{ fontWeight: 600, marginBottom: '1rem' }}>Change Password</h2>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <form onSubmit={(e) => { e.preventDefault(); mutation.mutate(); }}>
          <div className="form-group">
            <label>Current Password</label>
            <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8} />
          </div>
          <button className="btn btn-primary" type="submit" disabled={mutation.isPending}>
            {mutation.isPending ? 'Saving…' : 'Change Password'}
          </button>
        </form>
      </div>

      <div className="card">
        <h2 style={{ fontWeight: 600, marginBottom: '.5rem' }}>API Tokens</h2>
        <p style={{ fontSize: '.875rem', color: 'var(--color-text-muted)', marginBottom: '1rem' }}>
          Manage API tokens for MCP and programmatic access.
        </p>
        <Link to="/settings/tokens" className="btn btn-outline">Manage Tokens →</Link>
      </div>
    </div>
  );
}
